import { render } from "./mode_user.vue?vue&type=template&id=0ca28805&ts=true"
import script from "./mode_user.vue?vue&type=script&lang=ts"
export * from "./mode_user.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__